module.exports = __webpack_public_path__ + "img/journal-code.6db1bfa0.svg";